export var SLIDE_STATUS_LOADING = "loading";
export var SLIDE_STATUS_PLAYING = "playing";
export var SLIDE_STATUS_ERROR = "error";
export var SLIDE_STATUS_COMPLETE = "complete";
export var activeSlideStatus = function activeSlideStatus(status) {
  return "active-slide-".concat(status);
};
export var ACTIVE_SLIDE_LOADING = activeSlideStatus(SLIDE_STATUS_LOADING);
export var ACTIVE_SLIDE_PLAYING = activeSlideStatus(SLIDE_STATUS_PLAYING);
export var ACTIVE_SLIDE_ERROR = activeSlideStatus(SLIDE_STATUS_ERROR);
export var ACTIVE_SLIDE_COMPLETE = activeSlideStatus(SLIDE_STATUS_COMPLETE);